import React from "react"
import { avatarUrl, DEFAULT_AVATAR } from "./util/avatars"

const isProduction = process.env.NODE_ENV === "production"
const envURL =
  process.env.REACT_APP_API_URL || "https://cybersocial.herokuapp.com"
const API_URL = isProduction ? envURL : "http://localhost:8080"

// Author avatar with a neon ring — round by default, square for the
// forum-style author rail. Prefers the user's selected preset avatar,
// falls back to their legacy uploaded photo, then to the default image.
const UserAvatar = ({ user, size = 26, square = false }) => {
  const src =
    user && user.avatar
      ? avatarUrl(user.avatar)
      : user && user._id
      ? `${API_URL}/user/photo/${user._id}`
      : DEFAULT_AVATAR

  return (
    <img
      alt={(user && user.name) || "user"}
      src={src}
      onError={e => {
        if (!e.target.dataset.fellback) {
          e.target.dataset.fellback = "1"
          e.target.src = DEFAULT_AVATAR
        }
      }}
      style={{
        width: size,
        height: size,
        borderRadius: square ? 3 : "50%",
        objectFit: "cover",
        border: "1px solid rgba(0, 231, 255, 0.55)",
        boxShadow: "0 0 6px rgba(0, 231, 255, 0.35)",
        flexShrink: 0
      }}
    />
  )
}

export default UserAvatar
